import {signal} from "@preact/signals-react";

export const sideComparisonIsEmpty = signal(false)

export const resetSideComparisonSignals = () => {
    sideComparisonIsEmpty.value = false
}